module.exports = __webpack_public_path__ + "media/images/athletes/3204-ceda3ffcb8fdce89cde45d658d9f9ca6.png";